define('fukit/helpers/collection.util',['require','exports','module','underscore'],function(require, exports, module) {
  var _ = require('underscore');

  var CollectionUtil = {
    sortByStringValue: function(collection, fieldName, sortOrder) {
      var sortedModels = collection.sortBy(function(model) {
        var test = !!model.get(fieldName) ? model.get(fieldName) : '';
        return String(test).toLowerCase();
      });

      collection.models = sortOrder === 'descending' ? sortedModels.reverse() : sortedModels;

      return collection;
    },

    removeWhere: function(collection, options) {
      var entityToRemove = collection.findWhere(options);

      if (entityToRemove) {
        collection.remove(entityToRemove);
      }

      return entityToRemove;
    },

    clone: function(collection) {
      //prettier-ignore
      var models = collection.models,
          clonedCollection = new Backbone.Collection();

      _.each(models, function(model) {
        clonedCollection.add(model.clone());
      });

      return clonedCollection;
    },
  };

  module.exports = CollectionUtil;
});

